var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('path',{attrs:{"d":"m68.75 81.25h-50v-50h28.125l12.5-12.5h-53.125v75h75v-53.125l-12.5 12.5v28.125z"}}),_c('path',{attrs:{"d":"m100 0h-40.625l15.625 15.625-46.875 46.875 9.375 9.375 46.875-46.875 15.625 15.625v-40.625z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }